import { render, staticRenderFns } from "./Origins.vue?vue&type=template&id=391c7d44&scoped=true&"
import script from "./Origins.vue?vue&type=script&lang=js&"
export * from "./Origins.vue?vue&type=script&lang=js&"
import style0 from "./Origins.vue?vue&type=style&index=0&id=391c7d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c7d44",
  null
  
)

export default component.exports